<mat-card class="mt-3" *ngIf="!isBaseItem">
    <mat-card-content class="context-assignment-card-content">
        <div class="d-flex align-items-center component-header">
            <div class="flex-fill text-center">
                <h6 class="m-0 blue-text">Differences ({{ overridesLength }})</h6>
            </div>
        </div>
        <mat-divider class="card-divider"></mat-divider>
        <div class="accordion-container">
            <mat-accordion>
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title
                            matTooltip="This variation has different values for the following attributes compared to the standard base definition">
                            <mat-icon class="me-1" aria-label="Modifier Group">grain</mat-icon>
                            {{ variationHeader }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-divider class="mb-3"></mat-divider>
                    <div *ngIf="hasComponentOverrides">
                        <p>This variation has different set of components, see list above</p>
                    </div>
                    <br>
                    <mat-panel-description class="overflow-scroll">
                        <div>
                            <table mat-table [dataSource]="variation?.overrides | keyvalue | filterKey:'components'">
                                <ng-container matColumnDef="attribute">
                                    <th mat-header-cell *matHeaderCellDef><b>Attribute</b></th>
                                    <td mat-cell *matCellDef="let override"> {{ override.key }}</td>
                                </ng-container>

                                <ng-container matColumnDef="baseValue">
                                    <th mat-header-cell *matHeaderCellDef><b>Base Value</b></th>
                                    <td mat-cell *matCellDef="let override">
                                        {{ (item?.attributes | findAttribute:override.key) ?? item?.[override.key] ?? 'N/A' }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="override">
                                    <th mat-header-cell *matHeaderCellDef><b>Modified Value</b></th>
                                    <td mat-cell *matCellDef="let override"> {{ override.value }}</td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="['attribute', 'baseValue', 'override']"></tr>
                                <tr mat-row *matRowDef="let row; columns: ['attribute', 'baseValue', 'override'];"
                                    [attr.data-row-key]="row?.key"></tr>
                            </table>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </mat-card-content>
</mat-card>
